import { gql } from '@apollo/client';

export const GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM = gql`
  query GetTagesDaten($standortIds: [String!]!, $zeitraum: ZeitraumInput!) {
    termine_termineKalenderByStandortIdAndZeitraum(
      standortIds: $standortIds
      zeitraum: $zeitraum
    ) {
      id
      kalenderSchluessel
      name
      idStandort
      termine {
        id
        standortId
        titel
        datum
        beginn
        ende
        terminKalenderId
        image {
          name
          contentType
          url
          thumbnailUrl
        }
        markierung
        termineDetails {
          beschreibung
          specials
        }
        wiederholung
        wiederholungBis
        termine_arbeitszeiten {
          id
          datum
          beginn
          ende
          arbeitsbereich {
            markierung
            name
          }
          mitarbeiter {
            vorname
            nachname
            bildUrl
          }
        }
      }
    }
    termine_feiertageByStandortIdsAndZeitraum(
      standortIds: $standortIds
      zeitraum: $zeitraum
    ) {
      name
      datum
    }
  }
`;
